import ApplicationStyles from 'app/styles/ApplicationStyles';
import { Colors, Metrics } from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    avatarRoot: {
        justifyContent: 'center',
        display: 'flex',
    },
    card: {
        overflow: 'hidden',
        justifyContent: 'center',
        display: 'flex',
    },
    cardRoot: {
        marginRight: '8px',
        height: '100%',
        backgroundColor: '#fdfdfd'
        // position: 'absolute', 
        // height: '75%'
    },
    containerEmployeeCard:{
        marginTop: '25px'
    },
    root: {
        display: 'flex'
    },
    rootCommunication: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column-reverse',
        alignItems: 'center',
    },
    secondRoot: {
        width: '50%',
        marginTop: '1%'
    },
    rootEmployeeCard : {
        padding: theme.spacing(3,2),
        display: 'flex',
        width: '50%',
        alignItems: 'center',
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'justify',
    },
    appBarSpacer: theme.mixins.toolbar,
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginLeft: Metrics.baseMargin,
        marginRight: Metrics.baseMargin,
        height: 'auto',
    },
    button: {
        marginLeft: 8,
    },
    content: {
        flexGrow: 1,
        paddingBottom: 8,
        height: '100vh',
        overflow: 'auto',
    },
    tabContainer: {
        'marginLeft': Metrics.baseMargin,
        'marginRight': Metrics.baseMargin,
        display: 'flex',
        flexDirection: 'column',
        height: 'auto',
    },
    tab: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    fill: {
        height: 20,
        width: 20,
        borderRadius: 20,
        color: Colors.primary,
        backgroundColor: Colors.primary
    },
    empty: {
        borderRadius: 20,
        height: 20,
        width: 20,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: Colors.primary,
    },
    deleteIcon: {
        color: Colors.red,
        fontSize: 20,
    },
    editIcon: {
        color: Colors.primary,
        fontSize: 20,
    },
    buttons: {
        display: 'flex',
        flexDirection: 'row',
    },
    container: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row'
    },
    textItems: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    stepsContent: {
        marginTop: '16px',
        border: '1px dashed #e9e9e9',
        borderRadius: '6px',
        backgroundColor: '#fafafa',
        minHeight: '200px',
        textAlign: 'center',
        paddingTop: '80px',
    },
    stepAction: {
        marginTop: '24px'
    },
    stepStyle: {
        marginBottom: 40,
    },
    answersContainer: {
        alignContent: 'center',
        paddingBottom: '24px',
        marginTop: '10px'
    },
    paddingBottomInput : {
        paddingBottom: '80px',
    },
    spin: {
        textAlign: 'center',
    }
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
    titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect: {
        width: '100%',
        paddingRight: 8,
    },
    bottomDrawer: {
        position: 'fixed',
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e8e8e8',
        padding: '10px 16px',
        textAlign: 'right',
        left: 0,
        background: '#fff',
        borderRadius: '0 0 4px 4px',
    },
})

